module.exports = __webpack_public_path__ + "static/media/9.18e575cf.png";